import { z } from "zod";

export const MarketplaceCartShipToSchema = z.object({
  Name: z.string().optional(),
  Composite: z.string().optional(),
  AccountId: z.string().optional(),
  CountryId: z.string().optional(),
  Line1: z.string().optional(),
  Line2: z.string().optional(),
  City: z.string().optional(),
  StateOrProvince: z.string().optional(),
  PostalCode: z.string().optional(),
});

export type MarketplaceCartShipToType = z.infer<
  typeof MarketplaceCartShipToSchema
>;
